import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = '/studies';
// const REST_API_BASE_URL = '/api';

export const getAllStudies = () => axiosInstance.get(REST_API_BASE_URL);
export const getStudyById = (id) => axiosInstance.get(`${REST_API_BASE_URL}/${id}`);
export const createStudy = (study) => axiosInstance.post(REST_API_BASE_URL, study);
export const updateStudy = (id, study) => axiosInstance.put(`${REST_API_BASE_URL}/${id}`, study);
export const deleteStudy = (id) => axiosInstance.delete(`${REST_API_BASE_URL}/${id}`);

export const getTotalStudyCount = () => axiosInstance.get(`${REST_API_BASE_URL}/count`);

export const getStudiesByLevel = (level) => 
    axiosInstance.get(`${REST_API_BASE_URL}/search/by-level/${level}`);

export const getStudiesByUniversity = (universityName) => 
    axiosInstance.get(`${REST_API_BASE_URL}/search/by-university/${universityName}`);

export const getStudiesByCountry = (country) => 
    axiosInstance.get(`${REST_API_BASE_URL}/search/by-country/${country}`);

export const getStudiesByStudentId = (studentId) =>
    axiosInstance.get(`${REST_API_BASE_URL}/search/by-student/${studentId}`);

export const getStudyCountByStudentId = (studentId) =>
    axiosInstance.get(`${REST_API_BASE_URL}/count/by-student/${studentId}`);